/**
 * True when the given pathname is the progressive onboarding flow
 * (`/{locale}/start`). Used to suppress global promos/ads (PhotobookBanner,
 * Footer ad slot) during the distraction-free sign-up flow.
 */
export default function isOnboardingPath(pathname) {
  return (pathname || '').split('/')[2] === 'start';
}
